/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ matched: NonNullable<unknown>, inserted: NonNullable<unknown>, skipped: NonNullable<unknown> }} Event_Group_Sync_Status_CompleteInputs */

const en_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

const fr_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

const de_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

const it_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

const ru_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

const es_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

const zh_cn2_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

const ja_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

const hi_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

const pt_pt2_event_group_sync_status_complete = /** @type {(inputs: Event_Group_Sync_Status_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.matched} events. Inserted ${i?.inserted}. Skipped ${i?.skipped}.`)
};

/**
* | output |
* | --- |
* | "Synced {matched} events. Inserted {inserted}. Skipped {skipped}." |
*
* @param {Event_Group_Sync_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_status_complete = /** @type {((inputs: Event_Group_Sync_Status_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Status_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_sync_status_complete(inputs)
	if (locale === "de") return de_event_group_sync_status_complete(inputs)
	if (locale === "it") return it_event_group_sync_status_complete(inputs)
	if (locale === "ru") return ru_event_group_sync_status_complete(inputs)
	if (locale === "es") return es_event_group_sync_status_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_sync_status_complete(inputs)
	if (locale === "ja") return ja_event_group_sync_status_complete(inputs)
	if (locale === "hi") return hi_event_group_sync_status_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_sync_status_complete(inputs)
	return en_event_group_sync_status_complete(inputs)
});